export enum Layout {
  COMPACT = 'COMPACT',
  DEFAULT = 'DEFAULT',
}

export type PricingStrategy = {
  proposition?: string;
  paymentIntervalDisplay: number;
  viewMode: number;
  pricingTier: {
    paymentInterval: number;
    term: number;
  };
};

export default null;
